/*
  Griptape add-on submit handler. Pairs with snippets/griptape-addon.liquid,
  which renders a [data-grip-addon] radio control (no grip / Jessup / Mob)
  inside the product form when eligible.

  When "no grip" is selected (the default), this script does nothing and
  theme.js's own theme.AjaxProduct handles Add to Cart exactly as before --
  zero behavior change for every product without the control, and for grip-
  eligible products when the visitor doesn't ask for grip.

  When a paid grip option is selected, this script takes over the submit
  and adds BOTH the deck and the grip sheet in a single /cart/add.js
  items[] call (never two sequential calls -- a half-fail must not leave an
  orphan sheet in the cart), then replicates theme.js's own
  'ajaxProduct:added' / 'ajaxProduct:error' contract (see theme.js's
  theme.AjaxProduct.success/error, ~line 2747/2775) so the existing cart
  drawer/sticky-cart/count-bubble listeners -- and Bolty's generic
  fetch('/cart/add') watcher (assets/bolty.js ~line 957) -- all pick it up
  same as any other add.

  Listens on `document` in the CAPTURE phase, not on the form itself.
  Capture-phase listeners on an ancestor always run before a target's own
  (bubble-phase) listeners, regardless of registration order -- this is
  the only reliable way to run before theme.js's per-form AjaxProduct
  listener, which is (re)attached fresh to each form by theme.js's own
  section init and would otherwise fire its single-item add first. Because
  `document` itself is never replaced by PJAX (only #MainContent's
  innerHTML is), and every lookup below is done fresh from evt.target on
  each submit, this needs no PJAX re-init hook at all.
*/
(function () {
  function getSelectedGrip(addon) {
    var checked = addon.querySelector('input[data-grip-option]:checked');
    if (!checked || !checked.dataset.variantId) {
      return null;
    }
    return checked.dataset.variantId;
  }

  function getDeckQuantity(form) {
    // The quantity input (snippets/product-template.liquid's
    // quantity_selector block) is NOT nested inside <form> -- it's placed
    // alongside it and associated via a plain form="<form_id>" attribute
    // per the HTML forms spec, so form.querySelector() can't see it.
    // input.form is the live, spec-correct way to find "the input
    // belonging to this form" regardless of DOM position.
    var inputs = document.querySelectorAll('input[name="quantity"]');
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].form === form) {
        var parsed = parseInt(inputs[i].value, 10);
        return parsed > 0 ? parsed : 1;
      }
    }
    return 1;
  }

  function getDeckVariantId(form) {
    var idField = form.querySelector('[name="id"]');
    return idField ? idField.value : null;
  }

  function clearFormErrors(form) {
    var existing = form.querySelector('.errors');
    if (existing) {
      existing.remove();
    }
  }

  function showFormError(form, message) {
    clearFormErrors(form);
    var errorDiv = document.createElement('div');
    errorDiv.classList.add('errors', 'text-center');
    errorDiv.textContent = message;
    form.appendChild(errorDiv);
    form.dispatchEvent(new CustomEvent('ajaxProduct:error', {
      detail: { errorMessage: message },
      bubbles: true
    }));
  }

  function handleSubmit(evt) {
    var form = evt.target;
    if (!form || form.tagName !== 'FORM') {
      return;
    }

    var addon = form.querySelector('[data-grip-addon]');
    if (!addon) {
      return; // not a grip-eligible product form -- theme.js handles it as usual
    }

    var gripVariantId = getSelectedGrip(addon);
    if (!gripVariantId) {
      return; // "no grip" selected -- theme.js's normal single-item add runs untouched
    }

    var deckVariantId = getDeckVariantId(form);
    if (!deckVariantId) {
      return;
    }

    // Taking over: stop theme.js's own AjaxProduct submit handler on this
    // same form from also firing (it would add the deck a second time,
    // single-item, with no grip line).
    evt.preventDefault();
    evt.stopImmediatePropagation();

    var quantity = getDeckQuantity(form);
    var deckTitle = addon.getAttribute('data-deck-title') || '';
    var addToCartBtn = form.querySelector('[data-add-to-cart]');

    if (addToCartBtn) {
      addToCartBtn.classList.add('btn--loading');
    }
    clearFormErrors(form);

    var payload = {
      items: [
        { id: deckVariantId, quantity: quantity },
        {
          id: gripVariantId,
          quantity: quantity,
          properties: { 'Grip for': deckTitle }
        }
      ]
    };

    fetch(window.theme.routes.cartAdd, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(payload)
    })
      .then(function (response) { return response.json(); })
      .then(function (data) {
        if (addToCartBtn) {
          addToCartBtn.classList.remove('btn--loading');
        }

        if (data.status === 422 || data.description) {
          showFormError(form, data.description || data.message || 'Could not add to cart.');
          return;
        }

        form.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: {
            product: (data.items && data.items[0]) || data,
            addToCartBtn: addToCartBtn
          },
          bubbles: true
        }));

        if (document.body.classList.contains('template-cart')) {
          window.scrollTo(0, 0);
          location.reload();
        }
      })
      .catch(function () {
        if (addToCartBtn) {
          addToCartBtn.classList.remove('btn--loading');
        }
        showFormError(form, 'Could not add to cart.');
      });
  }

  document.addEventListener('submit', handleSubmit, true);
})();
